import axios from 'axios';
import store from '../../store';
import Config from '../../config';
import { mockDataSet, mockLeadIndicators } from '../mockData';

const { backendUrl } = Config.network;

axios.defaults.withCredentials = false;


export function reset() {
  return function action(dispatch) {
    setTimeout(function () {
      localStorage.setItem('dataCache', JSON.stringify(null));
    }, 100);
    dispatch({
      type: 'RESET_DATA_SETS',
    });
  };
}

export function getDataSet(processId) {
  return function action(dispatch) {
    const url = `${backendUrl}/api/production/data-sets/${processId}`;
    const { regionId, industryId } = store.getState().filter;
    const { cache } = store.getState().dataSet;
    const { branchPk } = store.getState().common;
    dispatch({
      type: 'МАКЕ_REQUEST',
    });
    if (!cache[processId]) {
      axios.get(
        url, {
          params: {
            region: regionId,
            industry: industryId,
            branch_pk: branchPk
          },
          headers: {
            'Cache-Control': 'no-cache'
          },
        },
      ).then((body) => {
        const { data } = body;
        cache[processId] = {
          [regionId]: {
            boiRanges: data['boi_ranges'],
            pmmQuestionnaireRanges: {
              policy: data['policy_four_step_ranges'],
              practice: data['practice_four_step_ranges'],
              platform: data['platform_four_step_ranges'],
            },
            pmmmPrioritizationGrid: data['project_prioritization_grids'],
            regionalComparsionCrossIndustry: data['regional_comparsion_cross_industry'],
            regionalComparsionSameIndustry: data['regional_comparsion_same_industry'],
            boiRangesChecked: [],
            leadRanges: [],
          },
          regionalComparisonData: data['regional_comparsion'],
        };
        setTimeout(function () {
          localStorage.setItem('dataCache', JSON.stringify(cache));
        }, 100);
        dispatch({
          type: 'GET_DATA_SET',
          payload: {
            cache,
            activeDataSet: cache[processId][regionId],
            activeRegionalComparison: cache[processId]['regionalComparisonData'],
          },
        });
        dispatch({
          type: 'REQUEST_SUCCESSFUL',
        });
      }).catch(error => {
        console.warn('[PMM] DataSet endpoint unreachable, using mock data:', error.message);
        dispatch({ type: 'SET_OFFLINE_MODE', payload: { offlineMode: true } });
        const mock = mockDataSet;
        cache[processId] = {
          [regionId]: {
            boiRanges: mock.boi_ranges || mock.boiRanges,
            pmmQuestionnaireRanges: {
              policy: mock.policy_four_step_ranges || [],
              practice: mock.practice_four_step_ranges || [],
              platform: mock.platform_four_step_ranges || [],
            },
            pmmmPrioritizationGrid: mock.project_prioritization_grids || [],
            regionalComparsionCrossIndustry: mock.regional_comparsion_cross_industry || {},
            regionalComparsionSameIndustry: mock.regional_comparsion_same_industry || {},
            boiRangesChecked: [],
            leadRanges: [],
          },
          regionalComparisonData: mock.regional_comparsion || { policy: [], regions: [] },
        };
        dispatch({
          type: 'GET_DATA_SET',
          payload: {
            cache,
            activeDataSet: cache[processId][regionId],
            activeRegionalComparison: cache[processId]['regionalComparisonData'],
          },
        });
        dispatch({ type: 'REQUEST_SUCCESSFUL' });
      });
    } else if (!cache[processId][regionId]) {
      axios.get(
        url, {
          params: {
            region: regionId,
            branch_pk: branchPk
          },
          headers: {
            'Cache-Control': 'no-cache'
          },
        },
      ).then((body) => {
        const { data } = body;
        cache[processId][regionId] = {
          boiRanges: data['boi_ranges'],
          pmmQuestionnaireRanges: {
            policy: data['policy_four_step_ranges'],
            practice: data['practice_four_step_ranges'],
            platform: data['platform_four_step_ranges'],
          },
          pmmmPrioritizationGrid: data['project_prioritization_grids'],
          regionalComparsionCrossIndustry: data['regional_comparsion_cross_industry'],
          regionalComparsionSameIndustry: data['regional_comparsion_same_industry'],
          boiRangesChecked: [],
          leadRanges: [],
        };
        setTimeout(function () {
          localStorage.setItem('dataCache', JSON.stringify(cache));
        }, 100);
        dispatch({
          type: 'GET_DATA_SET',
          payload: {
            cache,
            activeDataSet: cache[processId][regionId],
            activeRegionalComparison: cache[processId]['regionalComparisonData'],
          },
        });
        dispatch({
          type: 'REQUEST_SUCCESSFUL',
        });
      }).catch(error => {
        console.warn('[PMM] DataSet (region) endpoint unreachable, using mock data:', error.message);
        dispatch({ type: 'SET_OFFLINE_MODE', payload: { offlineMode: true } });
        const mock = mockDataSet;
        cache[processId][regionId] = {
          boiRanges: mock.boi_ranges || mock.boiRanges,
          pmmQuestionnaireRanges: {
            policy: mock.policy_four_step_ranges || [],
            practice: mock.practice_four_step_ranges || [],
            platform: mock.platform_four_step_ranges || [],
          },
          pmmmPrioritizationGrid: mock.project_prioritization_grids || [],
          regionalComparsionCrossIndustry: mock.regional_comparsion_cross_industry || {},
          regionalComparsionSameIndustry: mock.regional_comparsion_same_industry || {},
          boiRangesChecked: [],
          leadRanges: [],
        };
        dispatch({
          type: 'GET_DATA_SET',
          payload: {
            cache,
            activeDataSet: cache[processId][regionId],
            activeRegionalComparison: cache[processId]['regionalComparisonData'],
          },
        });
        dispatch({ type: 'REQUEST_SUCCESSFUL' });
      });
    } else {
      dispatch({
        type: 'GET_DATA_SET',
        payload: {
          cache,
          activeDataSet: cache[processId][regionId],
          activeRegionalComparison: cache[processId]['regionalComparisonData'],
        },
      });
      dispatch({
        type: 'REQUEST_SUCCESSFUL',
      });
    }
  };
}


export function checkIfActiveDataSet() {
  return function action(dispatch) {
    const { cache, activeDataSet, activeRegionalComparison } = store.getState().dataSet;
    const { regionId, processId } = store.getState().filter;
    if (activeDataSet['boiRanges'].length === 0 || activeRegionalComparison['policy'].length === 0) {
      dispatch({
        type: 'GET_DATA_SET',
        payload: {
          cache,
          activeDataSet: cache[processId][regionId],
          activeRegionalComparison: cache[processId]['regionalComparisonData'],
        },
      });
    }
  }
}


export function setLeadIndicators() {
  return function action(dispatch) {
    const url = `${backendUrl}/api/production/data-sets/set_related_lead_indicators`;
    const { cache } = store.getState().dataSet;
    const { regionId, processId } = store.getState().filter;
    dispatch({
      type: 'МАКЕ_REQUEST',
    });
    const { branchPk } = store.getState().common;
    axios.post(
      url,
      cache[processId][regionId]['boiRangesChecked'], {
        headers: {
          'Cache-Control': 'no-cache'
        },
        params: {
          branch_pk: branchPk
        }
      }).then((body) => {
      const { data } = body;

      function compare(a, b) {
        if (a.id < b.id) {
          return -1;
        }
        if (a.id > b.id) {
          return 1;
        }
        return 0;
      }

      const sortedData = data.sort(compare);
      const sortedDataActive = cache[processId][regionId]['leadRanges'].sort(compare);
      if (sortedData.length !== sortedDataActive.length) {
        cache[processId][regionId]['leadRanges'] = data;
        setTimeout(function () {
          localStorage.setItem('dataCache', JSON.stringify(cache));
        }, 100);
        dispatch({
          type: 'SET_LI_DATA',
          payload: {
            cache,
            activeDataSet: cache[processId][regionId],
          },
        });
        dispatch({
          type: 'REQUEST_SUCCESSFUL',
        });
        return;
      } else {
        for (let i = 0, length = sortedData.length; i < length; i += 1) {
          if (sortedData[i]['id'] !== sortedDataActive[i]['id']) {
            cache[processId][regionId]['leadRanges'] = data;
            setTimeout(function () {
              localStorage.setItem('dataCache', JSON.stringify(cache));
            }, 100);
            dispatch({
              type: 'SET_LI_DATA',
              payload: {
                cache,
                activeDataSet: cache[processId][regionId],
              },
            });
            dispatch({
              type: 'REQUEST_SUCCESSFUL',
            });
            return;
          }
        }
      }
      dispatch({
        type: 'SET_LI_DATA',
        payload: {
          cache,
          activeDataSet: cache[processId][regionId],
        },
      });
      dispatch({
        type: 'REQUEST_SUCCESSFUL',
      });
    }).catch(error => {
      console.warn('[PMM] Lead indicators endpoint unreachable, using mock data:', error.message);
      dispatch({ type: 'SET_OFFLINE_MODE', payload: { offlineMode: true } });
      cache[processId][regionId]['leadRanges'] = mockLeadIndicators;
      dispatch({
        type: 'SET_LI_DATA',
        payload: {
          cache,
          activeDataSet: cache[processId][regionId],
        },
      });
      dispatch({ type: 'REQUEST_SUCCESSFUL' });
    });
  };
}


export function manipulateFourStapsChart(category, chartId, value) {
  return function action(dispatch) {
    const { cache } = store.getState().dataSet;
    const { regionId, processId } = store.getState().filter;
    for (let i = 0, length = cache[processId][regionId]['pmmQuestionnaireRanges'][category].length; i < length; i += 1) {
      if (cache[processId][regionId]['pmmQuestionnaireRanges'][category][i]['id'] === chartId) {
        cache[processId][regionId]['pmmQuestionnaireRanges'][category][i]['value'] = value;
        break;
      }
    }
    for (let i = 0, length = cache[processId]['regionalComparisonData'][category]?.length; i < length; i += 1) {
      if (cache[processId]['regionalComparisonData'][category][i]['id'] === chartId) {
        cache[processId]['regionalComparisonData'][category][i]['value'] = value;
        break;
      }
    }
    setTimeout(function () {
      localStorage.setItem('dataCache', JSON.stringify(cache));
    }, 100);
    dispatch({
      type: 'UPDATE_FOUR_STEP_RANGES',
      payload: {
        cache,
        activeDataSet: cache[processId][regionId],
        activeRegionalComparison: cache[processId]['regionalComparisonData'],
      },
    });
  }
}


export function manipulateCheckedBoiRange(id) {
  return function action(dispatch) {
    const { cache } = store.getState().dataSet;
    const { regionId, processId } = store.getState().filter;
    const boiRangesCheckedBuffer = cache[processId][regionId]['boiRangesChecked'];
    const index = boiRangesCheckedBuffer.indexOf(id);
    if (index === -1) {
      boiRangesCheckedBuffer.push(id);
    } else {
      boiRangesCheckedBuffer.splice(index, 1);
    }
    cache[processId][regionId]['boiRangesChecked'] = boiRangesCheckedBuffer;
    setTimeout(function () {
      localStorage.setItem('dataCache', JSON.stringify(cache));
    }, 100);
    dispatch({
      type: 'CHANGE_BOI_CHECKED_ARRAY',
      payload: {
        cache,
        activeDataSet: cache[processId][regionId],
      },
    });
  }
}


export function manipulateBoiValue(chartId, value) {
  return function action(dispatch) {
    const { cache } = store.getState().dataSet;
    const { regionId, processId } = store.getState().filter;
    for (let i = 0, length = cache[processId][regionId]['boiRanges'].length; i < length; i += 1) {
      if (cache[processId][regionId]['boiRanges'][i]['id'] === chartId) {
        cache[processId][regionId]['boiRanges'][i]['value'] = value;
        break;
      }
    }
    setTimeout(function () {
      localStorage.setItem('dataCache', JSON.stringify(cache));
    }, 100);
    dispatch({
      type: 'UPDATE_BOI_LI_VALUE',
      payload: {
        cache,
        activeDataSet: cache[processId][regionId],
      },
    });
  }
}


export function manipulateLiValue(chartId, value) {
  return function action(dispatch) {
    const { cache } = store.getState().dataSet;
    const { regionId, processId } = store.getState().filter;
    for (let i = 0, length = cache[processId][regionId]['leadRanges'].length; i < length; i += 1) {
      if (cache[processId][regionId]['leadRanges'][i]['id'] === chartId) {
        cache[processId][regionId]['leadRanges'][i]['value'] = value;
        break;
      }
    }
    setTimeout(function () {
      localStorage.setItem('dataCache', JSON.stringify(cache));
    }, 100);
    dispatch({
      type: 'UPDATE_BOI_LI_VALUE',
      payload: {
        cache,
        activeDataSet: cache[processId][regionId],
      },
    });
  }
}
